export const PANEL_TAG_NAME = "panel" as const;

export const PANEL_WIDTHS = ["fill", "auto", "content"] as const;

export const PANEL_BORDERS = ["solid", "double", "glass"] as const;

export const PANEL_OVERFLOWS = ["clip", "visible"] as const;
